import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { getSessionMainId, getDecryptedUserFromCookie } from "./utils/getCookie";
import { decryptToken } from "./utils/getToken";
import { usePermissions } from "../context/PermissionContext";

function isTokenValid(token) {
  if (!token) return false;
  try {
    const decoded = jwtDecode(token);
    if (decoded.exp && decoded.exp * 1000 < Date.now()) {
      return false;
    }
    return true;
  } catch {
    return false;
  }
}

function ProtectedRoute({ children }) {
  const location = useLocation();
  const sessionId = getSessionMainId();
  const token = decryptToken("accessToken");
  const user = getDecryptedUserFromCookie();
  const { canAccessPath } = usePermissions();
  const isStaff = String(user?.type ?? "").toLowerCase() === "staff";

  if (!sessionId || !isTokenValid(token)) {
    return <Navigate to="/" replace />;
  }

  if (isStaff && !canAccessPath(location.pathname)) {
    return <Navigate to="/dashboard" replace state={{ accessDenied: true }} />;
  }

  return children;
}

export default ProtectedRoute;
